import { useRequest } from 'ahooks';

import {changeTheme,deleteTheme} from '../../../axios/api'

function useThemeAction(){

    const {loading:changeThemeLoading,data:changeThemeState,runAsync:changeThemeAction} = useRequest(
        async (params)=>{
            try {
                const resp = await changeTheme({
                    ...params
                });
                if(resp?.data?.status !== "success"){
                    // message.error("更新失败")
                    return false
                }    
                // message.success("已更新") 
                return true;
            }catch(error){
                // message.error('更新失败')
                return false
            }
        },
        {
            debounceWait: 240,
            manual: true,
        }
    );
    
    const {loading:deleteThemeLoading,data:deleteThemeState,runAsync:deleteThemeAction} = useRequest(
        async (params)=>{
            try {
                const resp = await deleteTheme({...params});
                if(resp?.data?.status !== "success"){
                    // message.error("删除失败")
                    return false
                }   
                // message.success("已删除") 
                return true;
            }catch(error){
                // message.error('删除失败')
                return false
            }
        },
        {
            debounceWait: 240,
            manual: true,
        }
    );

    return{
        changeThemeLoading,
        changeThemeState,
        changeThemeAction,
        deleteThemeLoading,
        deleteThemeState,
        deleteThemeAction,
    }
}

export default useThemeAction